/*****************************************************************************************
 * 설명 : 인디케이터 표시 처리
 * 작성자 : 송영석
 * 작성일 : 2021-05-21
*****************************************************************************************/
import Box from '@mui/material/Box';
import CircularProgress, {
  circularProgressClasses
} from '@mui/material/CircularProgress';
import { memo } from 'react';

import styled from 'styled-components';

/***************************************************************************************
 * 설명 : Indicator 를 감싸는 wrap <section> tag
 * 입력값 : isShow = true / false 표시 여부
***************************************************************************************/
const IndicatorWrap = styled.section`
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: 'block';
  z-index: 999998;
  top: 0px;
  left: 0px;
`;

/***************************************************************************************
* 설명 : Indicator 투명한 배경 영역
***************************************************************************************/
const IndicatorBackdrop = styled.div`
  position:fixed;
  width:100vw;
  height:100vh;
  background-color: rgba(0,0,0,1);
  opacity: 0;
  z-index: 999999999;
`;

/***************************************************************************************
* 설명 : Indicator 프로그래스 바 표시 영역
***************************************************************************************/
const IndicatorProgress = styled.div`
  position:fixed;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align:center;
  z-index:1000000;
  height:100vh;
  left: calc(50% - 75px);
`;

/***************************************************************************************
* 설명 : Indicator
***************************************************************************************/
const Indicator = memo(({ checked }) => {

  /***************************************************************************************
  * 설명 : Inspired by the former Facebook spinners.
  ***************************************************************************************/
  const FacebookCircularProgress = () => {
    return (
      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          sx={(theme) => ({
            color: theme.palette.grey[200],
            ...theme.applyStyles('dark', {
              color: theme.palette.grey[800],
            }),
          })}
          size={150}
          thickness={4}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={(theme) => ({
            color: '#1a90ff',
            animationDuration: '1.4s',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
            ...theme.applyStyles('dark', {
              color: '#308fe8',
            }),
          })}
          size={150}
          thickness={4}
        />
      </Box>
    );
  }

  if( checked ) {
    return (
      <IndicatorWrap>
        <IndicatorBackdrop></IndicatorBackdrop>
        <IndicatorProgress>
          <FacebookCircularProgress />
        </IndicatorProgress>
      </IndicatorWrap>
    )
  } else {
    return <></>
  }
})

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Indicator;